<template>
  <div class="container h-max w-max lp-1">
    <div class="modal is-active  m-t-xxl p-t-xxl">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Keep YOU fit - zdrowie i uroda</p>
        </header>
        <section class="modal-card-body">
          <h2>Przyłączysz się do nas? Keep YOU fit doprowadzi Cię do formy!</h2>
          <p v-show="errorText !== ''" class="p-sm ff-rb has-text-danger">{{ errorText }}</p>
          <div class="m-t-md m-b-md is-size-5">
            <span class="msisdn-prefix">+48 </span>
            <input type="phone" :class="'input msisdn-input is-link is-size-5 '" v-model="msisdn" name="" placeholder="MSISDN: 700 800 900" /> 
            <input type="submit" @click="send" class="msisdn-button button is-success is-link is-size-5" value="OK" />
          </div>
          <p class="ff-rl">Wypełnienie tego formularza oznacza akceptacje <router-link class="has-text-link ff-rl" :to="{ name: 'Terms' }">Regulaminu Usługi</router-link></p> 
        </section>
        <footer class="msisdn-footer modal-card-foot ff-rl ">
          <p> Usługę możesz dezaktywować poprzez: STOP KYF na 80425 (T-Mobile) lub 80708 (Orange). Opłata zostanie doliczona do Twojego rachunku w u twojego operatora (telefon na abonament) lub odliczona od środków na koncie (telefon na kartę).
          </p>
          <img class="p-l-sm image" src="static/dimoco/PL_orange_msisdn.png">
        </footer>
      </div>
    </div>
    <div id="a1" style="background-image: url(http://pl.keepyou.fit/static/lp/shutterstock_279475301.png);display:block;background-size:120%;" class="h-max w-max front-img is-uppercase has-text-weight-bold">
      <div style="background-image: linear-gradient(to bottom, transparent  90%, #f0f1f5);" class="h-max w-max">
          <div style="background-image: linear-gradient(to left, transparent  60%, #f0f1f5);" class="h-max w-max front-logo">
            <div class="p-t-sm p-l-sm">
              <p><img src="static/lp/muscle_heroes_edit.svg" class="icon is-xlarge"></p>
              <p class="is-size-5 has-text-black">Keep YOU fit</p><p class="is-size-6 has-text-black">Wszystko o fitnesie i żywieniu. <br>11,50 zł na tydźień</p>
            </div>
          </div>
      </div>
    </div>
    <div id="a3" class="h-max w-max is-vertical-center has-text-centered is-uppercase is-size-5" style="overflow:hidden;">
      <div class="is-fullwidth p-b-xl">
        <p class="is-size-2 has-text-weight-bold is-portrait">Seksowny brzuch,<br>kształtna pupa i nogi!</p>
        <p><img src="static/lp/icon_01a.png" style="height: 5rem;"><br>Idealny dla początkujących i zaawansowanych</p>
        <p><img src="static/lp/icon_02a.png" style="height: 5rem;"><br>Dowolnie anuluj online</p>
      </div>
    </div>
    <div id="a4" class="h-max w-max is-uppercase has-text-weight-bold">
      <div class="h-max w-max has-text-centered is-portrait" style="background-image: url(static/lp/food.png);background-size: 100% auto;background-position: top center;background-repeat:no-repeat;position: relative;">
        <div class="is-fullwidth" style="position: absolute;bottom: 7rem;">
          <p class="is-size-2 has-text-weight-bold">JESZ ŚWIADOMIE!</p>
        </div>
      </div>
      <div class="h-max w-max is-vertical-center has-text-centered is-landscape is-uppercase has-text-weight-bold" style="background-image: url(static/lp/food.png);background-size: 100% auto;background-position: center center;background-repeat:no-repeat;">
        <div class="is-fullwidth m-b-xxl" style="background: rgba(255,255,255,0.5);">
          <p class="is-size-2 has-text-weight-bold">JESZ ŚWIADOMIE!</p>
        </div>
      </div>
    </div>
    <div id="a5" class="m-b-lg w-max is-vertical-center has-text-centered is-uppercase has-text-weight-bold">
      <div class="is-fullwidth p-b-xl">
        <p><img src="static/lp/icon_03a.png" style="height: 5rem;"><br>Mało zasad, dużo wiedzy</p>
        <p><img src="static/lp/icon_04a.png" style="height: 5rem;"><br>Proste i szybkie przepisy kulinarne</p>
      </div>
    </div>
    <div id="a6" class="w-max is-size-7 m-b-xxl ff-rl">
      <p>Serwis Keep YOU fit stanowi świadczenie dodatkowe w ramach usługi o podwyższonej opłacie i jest tygodniowa usługą subskrypcyjną, która umożliwia tworzenie planu ćwiczeń i żywienia w taki sposób aby poprawić kondycję i sylwetkę.</p>
      <p>Koszt dostępu do Serwisu wynosi 11,50 zł (wraz z VAT) na tydzień brutto.</p>
      <p>Serwis dostępny jest na telefony komórkowe, posiadające kartę SIM w sieci Orange lub T-Mobile.</p>
      <p>Opłata zostanie doliczona do Twojego rachunku w u twojego operatora (telefon na abonament) lub odliczona od środków na koncie (telefon na kartę).</p>
      <p>Połączenie internetowe jest konieczne dla korzystania z otrzymanych w ramach Serwisu treści multimedialnych. Do opłaty za dostęp do Serwisu, nie są wliczone opłaty za transmisję danych. W przypadku gdy korzystanie z Serwisu wymaga pobierania przez Ciebie danych z wykorzystaniem transmisji GSM, opłaty te będą pobierane przez Operatora, zgodnie z aktualnym cennikiem zakontraktowanego Operatora.</p>
      <p>Aby dokonać zamówienia, musisz zapoznać się z treścią przedstawioną na Stronie Aktywacyjnej i podążać za instrukcjami na niej wskazanymi.</p>
      <p>Rejestracja do Serwisu jest jednoznaczna z akceptacją Regulaminu i Polityki Prywatności. Po rejestracji do Serwisu, otrzymasz bezpłatną wiadomość powitalną potwierdzającą, że rejestracja do usługi zakończyła się powodzeniem.</p>
      <p>Usługa jest aktywowana na czas nieokreślony, do czasu aż z niej zrezygnujesz. Aby dokonać rezygnacji należy wysłać SMS o treści STOP KYF na 80425 (T-Mobile) lub 80708 (Orange) (koszt: 0 zł).</p>
      <p>Usługodawcą i podmiotem realizującym dodatkowe świadczenie jest: 778mobile GmbH, Am Wehrhahn 50, DE-40211 Düsseldorf - Germany, zarejestrowany w Rejestrze Handlowym w Düsseldorfie pod numerem HRB 79227.</p>
      <p>Kontakt, w razie reklamacji: <a href="mailto:778mobile.pl@silverlines.info">778mobile.pl@silverlines.info</a> lub telefon: <a href="tel:221253450">221253450</a>.</p>
      <p class="has-text-weight-bold">Poprzez przyciśniecie na przycisk "OK" użytkownik wyraźnie potwierdza, że wie, że zamówienie pociąga za sobą obowiązek zapłaty poprzez rachunek telefoniczny według powyżej opisanej częstotliwości Serwisu. Dalej użytkownik potwierdza, że zapoznał się z treścią niniejszego Regulaminu organizatora i go wyraźnie akceptuje, a także zgadza się na natychmiastowe rozpocznie świadczenia Serwisu i związaną z tym utratę jego prawa do odstąpienia od umowy o udostępnianie Serwisu w przeciągu 14 dni. Ponadto, wyrażasz również zgodę na to, że niezwłoczne pobierzesz i zachowasz obowiązującą kopię Regulaminu usługi Organizatora w chwili zawarcia umowy o usługę (potwierdzenie zawarcia umowy), który będzie ci udostępniony (w postaci linka www) w otrzymanym przez ciebie SMS-ie potwierdzającym zawarcie umowy na usługę.</p>
    </div>
    <div class="has-text-centered fixed-bl is-fullwidth is-uppercase has-text-weight-bold">
      <div class="has-text-left is-size-7 has-text-grey is-family-secondary">
        <a class="has-text-grey" href="http://pl.keepyou.fit/#/terms-and-conditions">Regulamin Usługi</a> |
        <a class="has-text-grey" href="http://pl.keepyou.fit/#/imprint">O Nas</a> |
        <a class="has-text-grey" href="http://pl.keepyou.fit/#/help">Kontakt i Pomoc</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/LangMH/Header'
import Footer from '@/components/LangMH/Footer'

export default {
  name: 'Statisitc',
  data () {
    return {
      msisdn: this.$route.query.msisdn.substr(2) || '',
      default: true,
      requestId: this.$route.query.requestId,
      errorText: ''
    }
  },
  methods: {
    send() {
          const arr = this.msisdn.replace(' ', '').match(/^(\+48|0048|048|0)?([1-9][0-9]{8})$/)
          if (arr !== null) {
              document.location.replace(`/dimoco/mi/pl/0048${ arr[2] }?requestId=${ this.requestId || '' }`)
          } else {
            this.default = false
          }
      }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.is-vertical-center {
display: flex;
align-items: center;
}
.shadow {
-webkit-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
-moz-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
}
.steps .steps-marker {
    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%);
}

.h-max {
    min-height: 100%;
    height: 100%;
}
.w-max {
    min-width: 100%;
    width: 100%;
}
.fixed-tl {
    position: fixed;
    top:0;
    left: 0;
}
.fixed-bl {
    position: fixed;
    bottom:0;
    left: 0;
}
.fixed-tr {
    position: fixed;
    top:0;
    right: 0;
}
.fixed-br {
    position: fixed;
    bottom:0;
    right: 0;
}
.lh-1 {
    line-height: 1 !important;
}
.bg-point {
    background-color: transparent;
    background-image: radial-gradient(#f99819 50%, transparent 51%, transparent 60%, #f99819 61%, #f99819 65%, transparent 66%);
}

.front-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 100%;
}
.invert-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
}
@media screen and (orientation:landscape) {
    .front-img {
        background-size: 100% auto;
    }
    .invert-img {
        background-size: auto 100%;
        background-position: top left;
    }
    .front-logo {
        display: block;
    }
    .is-portrait {
        display: none;
    }
}
@media screen and (orientation:portrait) {
    .is-landscape {
        display: none;
    }
}
.lp-1 .modal-card-head, .lp-1 .modal-card-body, .lp-1 .modal-card-foot {
  padding: 12px;
}
.lp-1 .modal-card {
      margin-top: 4rem;
    }
.lp-1 .modal-card-title {
  font-size: 1rem;
}
.lp-1 .modal-card-body h2 {
  font-size: 0.9rem;
}
.lp-1 .modal-card-body p, .lp-1 .modal-card-foot p {
  font-size: 0.7rem !important;
}
.pin-control {
    width: 75%;
} 
.pin-input {
    border-radius: 4px;
    border-width: 2px;
    background: #fff9d7;
    border-color: #e2c822 !important;
}
.msisdn-button {
  width: 15%;
  margin-left: 2%;
}
.msisdn-prefix {
  line-height: 2.2;
  display: inline-block;
  width: 10%;
  margin-right: 2%;
  text-align: right;
}
.msisdn-input {
    border-radius: 4px;
    border-width: 2px;
    background: #fff9d7;
    border-color: #e2c822 !important;
    width: 65%;
}
.msisdn-input:hover, .msisdn-input:focus {
    border-radius: 4px;
    border-width: 2px;
    -webkit-box-shadow: 0px 0px 10px 5px rgba(200,200,200,0.5);
    -moz-box-shadow: 0px 0px 10px 5px rgba(200,200,200,0.5);
    box-shadow: 0px 0px 10px 5px rgba(200,200,200,0.5);
}
input.invalid, input.invalid:hover, input.invalid:focus {
    border-color: red !important;
}
@media (orientation: landscape) {
    .lp-1 .modal-card {
      margin-top: 0rem;
    }
    .lp-1-logo {
      display: none;
    }
    .main {
        background: white url(/static/mh-man.jpg) center center no-repeat;
        background-size: auto 100%;
    }
}
.h-max {
    min-height: 100%;
    height: 100%;
}
.w-max {
    min-width: 100%;
    width: 100%;
}
.fixed-bl {
    position: fixed;
    bottom:0;
    left: 0;
}
@keyframes bg-slide {
    from { transform: translateY(0); }
    to { transform: translateY(-50%); }
}
@-webkit-keyframes bg-slide {
    from { transform: translateY(0); }
    to { transform: translateY(-50%); }
}

.lp-1-logo {
  z-index: 100;
  position: absolute;
  padding: 3rem;
  background: radial-gradient(rgba(255,255,255,0.8), transparent 70%);
  top: -2rem;
  left: -2rem;
}

.lp-1 .front-img .image {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/LangKyf/PL/EntryList.vue